var _mask, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFallingMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 10000,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "falling-mask_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h301v962H0z",
    transform: "translate(0 9038)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M301 0H0v917h.038c-.025.332-.038.666-.038 1 0 24.301 67.26 44 150.229 44 82.969 0 150.228-19.699 150.228-44 0-.334-.013-.668-.038-1H301V0z",
    transform: "translate(0 9038)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h301v9050H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#falling-mask_svg__a)",
    d: "M0 0h301v10000H0z"
  })));
}

export default "data:image/svg+xml;base64,CjxzdmcgIHdpZHRoPSIzMDEiIGhlaWdodD0iMTAwMDAiIHZpZXdCb3g9IjAgMCAzMDEgMTAwMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CgkJCQkJCTwhLS0gOTYyIC0tPgogICAgPG1hc2sgaWQ9Im1hc2stZmFsbCI+CiAgICAgICAgCiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA5MDM4KSI+ICAgCiAgICAgICAgICAgIDxyZWN0IGZpbGw9ImJsYWNrIiB3aWR0aD0iMzAxIiBoZWlnaHQ9Ijk2MiIgeD0iMCIgeT0iMCIgLz4KICAgICAgICAgICAgPCEtLSA8cmVjdCBmaWxsPSJ3aGl0ZSIgd2lkdGg9IjE1MCIgaGVpZ2h0PSI5NjIiIHg9IjAiIHk9IjAiIC8+IC0tPgogICAgICAgICAgICA8cGF0aCBmaWxsPSJ3aGl0ZSIgZD0iTTMwMSAwSDBWOTE3SDAuMDM4MDI0OUMwLjAxMjY5NTMgOTE3LjMzMiAwIDkxNy42NjYgMCA5MThDMCA5NDIuMzAxIDY3LjI1OTYgOTYyIDE1MC4yMjkgOTYyQzIzMy4xOTggOTYyIDMwMC40NTcgOTQyLjMwMSAzMDAuNDU3IDkxOEMzMDAuNDU3IDkxNy42NjYgMzAwLjQ0NCA5MTcuMzMyIDMwMC40MTkgOTE3SDMwMVYwWiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgICAgICA8cmVjdCBmaWxsPSJ3aGl0ZSIgd2lkdGg9IjMwMSIgaGVpZ2h0PSI5MDUwIiB4PSIwIiB5PSIwIiAvPgogICAgPC9tYXNrPgoKICAgIDxyZWN0IGZpbGw9ImJsYWNrIiB3aWR0aD0iMzAxIiBoZWlnaHQ9IjEwMDAwIiB4PSIwIiB5PSIwIiBtYXNrPSJ1cmwoI21hc2stZmFsbCkiLz4KICAgIAoKPC9zdmc+";
export { SvgFallingMask as ReactComponent };